import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex justify-center py-10" }
const _hoisted_2 = { class: "active" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "line" }, null, -1)),
    _createElementVNode("ul", null, [
      _createElementVNode("li", _hoisted_2, [
        _createVNode(_component_router_link, { to: "/" }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createTextVNode("Home", -1)
          ]))]),
          _: 1
        })
      ]),
      _cache[2] || (_cache[2] = _createElementVNode("li", null, [
        _createElementVNode("a", {
          target: "_black",
          href: "https://drive.google.com/file/d/1ogLIyJyVpLSCpjovSe3fkoV7Xu5DTvW1/view?usp=sharing"
        }, "Get a copy of my CV ")
      ], -1)),
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, { to: "timeline" }, {
          default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
            _createTextVNode("timeline", -1)
          ]))]),
          _: 1
        })
      ])
    ])
  ]))
}